import React from 'react';
import classNames from 'classnames';
import CategoryIcon from '../CategoryIcon/CategoryIcon';
import TransactionModelBadge from '../TransactionModelBadge/TransactionModelBadge';
import css from './SelectedCategoryCard.module.css';

/**
 * Read-only summary of the category a merchant chose in step 1.
 *
 * Shown in place of the category dropdowns once a category is locked in. Both
 * levels are named: the two dropdowns it replaces showed both, and the
 * subcategory alone ("Electrical") does not say which section of the catalogue
 * the listing lands in.
 *
 * @param {Object} category the chosen subcategory, a child node from
 *   transformDbCategories (label, iconUrl, activeConfig). Renders nothing
 *   without one — callers fall back to the editable dropdowns in that case.
 * @param {Object} [parentCategory] its parent. Optional: the parent line is
 *   dropped rather than the whole card if a caller cannot resolve it.
 */
const SelectedCategoryCard = props => {
  const { category, parentCategory, className } = props;

  if (!category) return null;

  return (
    <div className={classNames(css.card, className)}>
      <CategoryIcon category={category} parent={parentCategory} className={css.icon} />
      <span className={css.text}>
        {parentCategory ? (
          <span className={css.parentLabel}>{parentCategory.label}</span>
        ) : null}
        <span className={css.label}>{category.label}</span>
      </span>
      <TransactionModelBadge config={category.activeConfig} />
    </div>
  );
};

export default SelectedCategoryCard;
